<!-- HTML -->
<template>
  <div>

    <section class="hero is-fullheight">
      <div class="floating-rects-container" ref="floatingRectsContainer">
        <div id="rect-0" class="rect" ref="rect0"></div>
        <div id="rect-1" class="rect" ref="rect1"></div>
        <div id="rect-2" class="rect" ref="rect2"></div>
        <div id="rect-3" class="rect" ref="rect3"></div>
        <div id="rect-4" class="rect" ref="rect4"></div>
        <div id="rect-5" class="rect" ref="rect5"></div>
        <div id="rect-6" class="rect" ref="rect6"></div>
        <div id="rect-7" class="rect" ref="rect7"></div>
        <div id="rect-8" class="rect" ref="rect8"></div>
        <div id="rect-9" class="rect" ref="rect9"></div>
        <div id="rect-10" class="rect" ref="rect10"></div>
        <div id="rect-11" class="rect" ref="rect11"></div>
        <div id="rect-12" class="rect" ref="rect12"></div>
        <div id="rect-13" class="rect" ref="rect13"></div>
      </div>
    </section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "HomeBarbedWireHand",

  methods: {

    // Create Observer Function Constructor
    createObserver( myRoot, myRootMargin, myThreshold, myTarget, myTransitionDuration, myTransitionDelay ) { // Pass in options when called
     let observer;
     let options = {
       root: myRoot,
       rootMargin: myRootMargin,
       threshold: myThreshold
     };

     myTarget.style.transitionDuration = myTransitionDuration;
     myTarget.style.transitionDelay = myTransitionDelay;

     // Create a new IntersectionObserver with the constructor
     observer = new IntersectionObserver(this.handleIntersect, options);

     // Target HTML element that we will be watching is #box
     observer.observe(myTarget);

    },

    // Create Threshold List Function
    buildThresholdList( myNumSteps) {
      let thresholds = [];
      let numSteps = myNumSteps; // Number of steps
      for (let i=1.0; i<=numSteps; i++) {
        let ratio = i/numSteps;
        thresholds.push(ratio);
      }
      thresholds.push(0);
      return thresholds;
    },

    // Function that is run whenever the element is observed per the threshold
    // The callback function is automatically passed the intersectionObserverEntry object, which can be referenced with "entries"
    handleIntersect(entries) {

      // Set the speed of all the rectangles, in order, higher number is faster
      let position = 0;
      let speeds = [
        // Top Rectangles
        60, // 0
        90, // 1
        30, // 2
        50, // 3
        80, // 4
        70, // 5
        40, // 6
        // Bottom Rectangles
        30, // 7
        80, // 8
        60, // 9
        90, // 10
        40, // 11
        70, // 12
        50 // 13
      ];

      for ( let i = 0; i < speeds.length; i++ ) {

        // Variables
        let rect = "rect" + i,
            slideAmt,
            speed, // Speed of movement
            corrector; // Corrects movement once halfway through the observer

        speed = speeds[i]; // Set the speed of rectangle
        corrector = speed * 2; // Set the corrector amount

        // position variable determines if it is the top or bottom rectangles
        if ( position <= 6 ) { // Top Rectangels

          if ( entries[0].intersectionRect.height === entries[0].intersectionRect.bottom && entries[0].isIntersecting === true ) {
            slideAmt = corrector - (entries[0].intersectionRatio * speed);
            slideAmt = "translateY(" + slideAmt + "px)";
          } else {
            slideAmt = entries[0].intersectionRatio * speed;
            slideAmt = "translateY(" + slideAmt + "px)";
          }

        } else { // Bottom Rectangles

          if ( entries[0].intersectionRect.height === entries[0].intersectionRect.bottom && entries[0].isIntersecting === true ) {
            slideAmt = corrector - (entries[0].intersectionRatio * speed);
            slideAmt = "translateY(-" + slideAmt + "px)";
          } else {
            slideAmt = entries[0].intersectionRatio * speed;
            slideAmt = "translateY(-" + slideAmt + "px)";
          }

        }

        position++;

        // Transform the slider
        this.$refs[rect].style.transform = slideAmt;

      }

    },

    // Create all the Intersection Observers
    createIntersectionObservers() {

      this.createObserver( null, '0px', this.buildThresholdList(200), this.$refs.floatingRectsContainer, 0, 0 );

    }

  },

  mounted() {

    this.createIntersectionObservers();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.hero {
  background: url("../../assets/img/home/barbed-wire-hand.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.floating-rects-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.rect {
  position: absolute;
}

/* Widths Top */
$rect-0-w: 18vw;
$rect-1-w: 10vw;
$rect-2-w: 34vw;
$rect-3-w: 22vw;
$rect-4-w: 16vw;
$rect-5-w: 12vw;
$rect-6-w: 16vw;

/* Widths Bottom */
$rect-7-w: 10vw;
$rect-8-w: 18vw;
$rect-9-w: 30vw;
$rect-10-w: 12vw;
$rect-11-w: 22vw;
$rect-12-w: 28vw;
$rect-13-w: 16vw;

/* Top Rectangles */
#rect-0 {
  top: -60px;
  left: 0;
  width: $rect-0-w;
  height: 20vh;
  background-color: rgba(0,0,0,.4);
}
#rect-1 {
  top: -90px;
  left: $rect-0-w - 2;
  width: $rect-1-w;
  height: 30vh;
  background-color: rgba(0,0,0,.1);
}
#rect-2 {
  top: -30px;
  left: $rect-0-w + $rect-1-w - 6;
  width: $rect-2-w;
  height: 5vh;
  background-color: rgba(0,0,0,.7);
}
#rect-3 {
  top: -50px;
  left: $rect-0-w + $rect-1-w + $rect-2-w - 18;
  width: $rect-3-w;
  height: 18vh;
  background-color: rgba(0,0,0,.5);
}
#rect-4 {
  top: -80px;
  left: $rect-0-w + $rect-1-w + $rect-2-w + $rect-3-w - 20;
  width: $rect-4-w;
  height: 15vh;
  background-color: rgba(0,0,0,.2);
}
#rect-5 {
  top: -70px;
  left: $rect-0-w + $rect-1-w + $rect-2-w + $rect-3-w + $rect-4-w - 24;
  width: $rect-5-w;
  height: 30vh;
  background-color: rgba(0,0,0,.3);
}
#rect-6 {
  top: -40px;
  left: $rect-0-w + $rect-1-w + $rect-2-w + $rect-3-w + $rect-4-w + $rect-5-w - 28;
  width: $rect-6-w;
  height: 26vh;
  background-color: rgba(0,0,0,.6);
}

/* Bottom Rectangles */
#rect-7 {
  bottom: -60px;
  left: 0;
  width: $rect-7-w;
  height: 20vh;
  background-color: rgba(0,0,0,.4);
}
#rect-8 {
  bottom: -150px;
  left: $rect-7-w - 2;
  width: $rect-8-w;
  height: 30vh;
  background-color: rgba(0,0,0,.1);
}
#rect-9 {
  bottom: -120px;
  left: $rect-7-w + $rect-8-w - 6;
  width: $rect-9-w;
  height: 15vh;
  background-color: rgba(0,0,0,.3);
}
#rect-10 {
  bottom: -180px;
  left: $rect-7-w + $rect-8-w + $rect-9-w - 10;
  width: $rect-10-w;
  height: 24vh;
  background-color: rgba(0,0,0,.5);
}
#rect-11 {
  bottom: -80px;
  left: $rect-7-w + $rect-8-w + $rect-9-w + $rect-10-w - 20;
  width: $rect-11-w;
  height: 15vh;
  background-color: rgba(0,0,0,.2);
}
#rect-12 {
  bottom: -140px;
  left: $rect-7-w + $rect-8-w + $rect-9-w + $rect-10-w + $rect-11-w - 24;
  width: $rect-12-w;
  height: 30vh;
  background-color: rgba(0,0,0,.3);
}
#rect-13 {
  bottom: -100px;
  left: $rect-7-w + $rect-8-w + $rect-9-w + $rect-10-w + $rect-11-w + $rect-12-w - 28;
  width: $rect-13-w;
  height: 22vh;
  background-color: rgba(0,0,0,.6);
}

</style>
